export default __webpack_public_path__ + "static/media/user-with-bg.06ab8ce9.svg";